class CustomShippingBar {
  constructor() {
    this.minAmount;
    this.selector = {
      bar: '.free-shipping-bar__bar__progress',
      message: '.free-shipping-bar__info__message',
      container: '.free-shipping-bar'
    };
    
    if (this.checkExperimentVariant()) {
      this.init();
      this.setupMutationObserver();
    }
  }

  checkExperimentVariant() {
      try {
        const experimentData = localStorage.getItem('abconvert-shippingxp');
        
        if (!experimentData) {
          return false;
        }
        
        const parsedData = JSON.parse(experimentData);
        
        if (parsedData && (parsedData.variant === 1 || parsedData.variant === 2)) {
          if (parsedData.variant === 1) {
            this.minAmount = 69;
          } else if (parsedData.variant === 2) {
            this.minAmount = 59;
          }
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    };

  init() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this.cartData = cart;
        this.updateProgressBar();
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          const shippingBar = document.querySelector(this.selector.container);
          if (shippingBar) {
            this.init();
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  updateProgressBar() {
    const cartTotal = this.cartData.total_price / 100;
    const amount = Math.max(0, this.minAmount - cartTotal);
    const progress = Math.min(100, (cartTotal * 100) / this.minAmount);
    
    const progressBar = document.querySelector(this.selector.bar);
    const messageElement = document.querySelector(this.selector.message);
    
    if (progressBar) {
      progressBar.style.width = `${progress}%`;
    }

    if (messageElement) {
      if (cartTotal >= this.minAmount) {
        messageElement.textContent = '¡Envío gratis disponible!';
      } else {
        if (amount >= 1) {
          messageElement.textContent = `Añade ${Math.floor(amount)}€ más para obtener envío gratuito`;
        } else {
          messageElement.textContent = `Añade ${amount.toFixed(2)}€ más para obtener envío gratuito`;
        }
      }
    }
  }
}

document.addEventListener('abconvert:shipping:initialized', (event) => {
  const shippingTestData = event.detail.shippingTestData;
  console.log('abconvert:shipping:initialized: shippingTestData', shippingTestData);
  window.customShippingBar = new CustomShippingBar();
});